module.exports = __webpack_public_path__ + "static/media/3.164950be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/3.jpg
// module id = 98
// module chunks = 0